import { render, staticRenderFns } from "./rule-config.vue?vue&type=template&id=31139a6d&scoped=true"
import script from "./rule-config.vue?vue&type=script&lang=js"
export * from "./rule-config.vue?vue&type=script&lang=js"
import style0 from "./rule-config.vue?vue&type=style&index=0&id=31139a6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31139a6d",
  null
  
)

export default component.exports